import { useHomeCollection } from '@/reducers/homeResource'

export default function useHomeEstimationCompletion() {
  const home = useHomeCollection()
  return home && !home.has_user_defined_fields
}
